exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".shape-link-flag-shape-link-2DSZc{background-color:#0188fb;border-radius:50%;pointer-events:auto;position:absolute}", ""]);

// Exports
exports.locals = {
	"shape-link": "shape-link-flag-shape-link-2DSZc"
};